var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgFail = function SvgFail(props) {
  var _id7 = useUniqueInlineId();
  var _id6 = useUniqueInlineId();
  var _id5 = useUniqueInlineId();
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.525%",
    y1: "93.028%",
    x2: "69.71%",
    y2: "-6.043%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F1FF",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7DDFF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.125%",
    y1: "6.972%",
    x2: "20.94%",
    y2: "106.043%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF7FF",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9D3FF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.363%",
    y1: "6.972%",
    x2: "21.176%",
    y2: "106.028%",
    id: _id3
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E6FF",
    offset: "0%"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC2FF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.041%",
    y1: "-6.972%",
    x2: "6.936%",
    y2: "2.385%",
    id: _id4
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEDEFF",
    stopOpacity: 0.24,
    offset: "0%"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED9FF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.451%",
    y1: "92.327%",
    x2: "40.286%",
    y2: "1.483%",
    id: _id5
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF",
    offset: "0%"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "93.028%",
    x2: "86.056%",
    y2: "-6.972%",
    id: _id6
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF",
    offset: "0%"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "93.027%",
    x2: "86.056%",
    y2: "-6.973%",
    id: _id7
  }, _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF",
    offset: "0%"
  })), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 30)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.6,
    fill: "url(#".concat(_id, ")"),
    transform: "rotate(15 35.487 26.932)",
    x: 18.537,
    y: 6.232,
    width: 33.9,
    height: 41.4,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.6,
    fill: "url(#".concat(_id2, ")"),
    transform: "rotate(15 35.487 26.932)",
    x: 18.537,
    y: 6.232,
    width: 33.9,
    height: 41.4,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.098 1.7a1.6 1.6 0 011.6-1.6h26.795l13.74 13.74V50.1a1.6 1.6 0 01-1.6 1.6H1.698a1.6 1.6 0 01-1.6-1.6V1.7z",
    fillOpacity: 0.6,
    fill: "url(#".concat(_id3, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.098 1.7a1.6 1.6 0 011.6-1.6h26.795l13.74 13.74V50.1a1.6 1.6 0 01-1.6 1.6H1.698a1.6 1.6 0 01-1.6-1.6V1.7z",
    fill: "url(#".concat(_id4, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.474 19.25a2.636 2.636 0 115.25 0l-.99 10.944a1.642 1.642 0 01-3.271 0l-.99-10.944z",
    fill: "url(#".concat(_id5, ")"),
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#".concat(_id6, ")"),
    opacity: 0.8,
    cx: 21.099,
    cy: 35.035,
    r: 1.731
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.449.1l13.74 13.74h-12.14a1.6 1.6 0 01-1.6-1.6V.1z",
    fill: "url(#".concat(_id7, ")"),
    opacity: 0.4
  })));
};
export default SvgFail;